import { all, put, takeEvery } from 'redux-saga/effects';
import {
  doSubmit, startSubmit, stopSubmit, reset,
} from 'circe/forms/actions';
import { operatorClient } from 'domain/HttpClients';
import { formatRequest } from 'domain/vehicle/components/updateInfo/utils';
import { show as showNotification } from 'circe/notifications/actions';
import { FORM_NAME } from './constants';

function* doUpdateVehicle(context, action) {
  if (action.payload.name !== FORM_NAME) return;

  yield put(startSubmit(FORM_NAME));

  try {
    const {
      payload: { values },
    } = action;

    yield updateVehicleInformation(values);

    yield put(reset(FORM_NAME));
    yield put(showNotification('Vehicle Updated Successfully', 'success'));
    setTimeout(() => {
      context.history.push('/vehicles');
    }, 2000);
  } catch (e) {
    yield put(showNotification(e.message, 'error'));
    console.error(e);
  } finally {
    yield put(stopSubmit(FORM_NAME));
  }
}

function* updateVehicleInformation(values) {
  const { truckDetails } = values;
  const dataRequest = formatRequest(truckDetails);
  const { data, vehicleId } = dataRequest;
  try {
    const response = yield operatorClient
      .Patch(`/api/vehicles/${vehicleId}`)
      .withData(data)
      .send();
  } catch (e) {
    console.error(e);
    throw new Error(e);
  }
}

function* watcher(context) {
  yield all([takeEvery(doSubmit().type, doUpdateVehicle, context)]);
}

export default watcher;
